module.exports = __webpack_public_path__ + "img/banner-en.9d71c92c.png";